import React from "react";
import { Title } from "../../components/title/title.component";
import "./subscribe-thank-you.styles.css";
import Button from "../../components/button/button.component";

const SubscribeThankYou = (props) => {
    return(
        <div className="subscribe-thank-you">
            <div style={{fontSize:"75px"}}>&#x2728;</div>
            <Title 
                title="YOUR SUBSCRIPTION<br/>HAS BEEN CREATED" 
                description={`Thank you for subscribing to Tum To Mom Box! We'll email you an order confirmation with details and tracking information, and the first box will ship in 2-3 business days!`}
                descstyle = {{width:"418px"}}
            ></Title>
            <Button text="go to homepage" href="/" sx={{width:"170px"}}></Button>
        </div>
    )
}
export default SubscribeThankYou;